module.exports = __webpack_public_path__ + "img/barzahlen-alternative.d33f1a0b.png";